import { create } from 'zustand';

interface UiState {
  /** Universelle Suche (Command-Palette, ⌘K / Strg+K) offen? — ADR 0015. */
  isSearchOpen: boolean;
  /** Suche über „+" der Tab-Leiste geöffnet: Die Auswahl landet in einem neuen Tab (ADR 0111). */
  searchOpensNewTab: boolean;
  setSearchOpen: (open: boolean, options?: { inNewTab?: boolean }) => void;
  /** Tastenkürzel-Übersicht (Spickzettel, „?") offen? */
  isShortcutsOpen: boolean;
  setShortcutsOpen: (open: boolean) => void;
}

// Den Sidebar-Zustand verwaltet der SidebarProvider (@proerp/ui) selbst
// (Cookie-persistiert, Strg/⌘+B) — hier lebt nur noch App-weiter UI-State.
export const useUiStore = create<UiState>((set) => ({
  isSearchOpen: false,
  searchOpensNewTab: false,
  setSearchOpen: (open, options) => set({ isSearchOpen: open, searchOpensNewTab: open && Boolean(options?.inNewTab) }),
  isShortcutsOpen: false,
  setShortcutsOpen: (open) => set({ isShortcutsOpen: open }),
}));
